module.exports = __webpack_public_path__ + "static/img/mibm-course.37a6df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/mibm-course.png
// module id = uTlG
// module chunks = 2